const emulatePrintMedia = (source: string, mediaAttribute = false): string => {
  let inMediaQuery = mediaAttribute;
  let parentheses = 0;
  const tokens = /\/\*[\s\S]*?(?:\*\/|$)|"(?:\\[\s\S]|[^"\\])*"|'(?:\\[\s\S]|[^'\\])*'|@[-\w]+|[-\w]+|[\s\S]/g;
  return source.replace(tokens, (token) => {
    const normalized = token.toLowerCase();
    if (normalized === '@media' && parentheses === 0) inMediaQuery = true;
    else if (token === '(') parentheses += 1;
    else if (token === ')') parentheses = Math.max(0, parentheses - 1);
    else if (token === '{' || token === ';') inMediaQuery = mediaAttribute;
    else if (inMediaQuery && parentheses === 0) {
      if (normalized === 'print') return 'screen';
      if (normalized === 'screen') return 'print';
    }
    return token;
  });
};

export const createPrintPreviewDocument = (source: string): string => {
  const document = new DOMParser().parseFromString(source, 'text/html');
  document.querySelectorAll('style').forEach((style) => {
    style.textContent = emulatePrintMedia(style.textContent ?? '');
  });
  document.querySelectorAll('style[media], link[media]').forEach((element) => {
    element.setAttribute('media', emulatePrintMedia(element.getAttribute('media') ?? '', true));
  });
  return `<!DOCTYPE html>\n${document.documentElement.outerHTML}`;
};

